"use client";
import * as React from "react";
import { useState } from "react";

interface PropsType {
  text: string;
  label: string;
  copyDoneCallback?: (info: { operation: "COPY" }) => void;
  classNames?: {
    container?: string;
    label?: string;
    input?: string;
  };
}

import styles from "../index.module.css";
import CopyToClipboardButton from "../../ClipboardButton/index";
import cssClassAssembler from "../../../sso/utils/cssClassAssembler";
import Spacer from "../../Spacer/index";

function InputWithCopyButton(props: PropsType) {
  const [id, setId] = useState(() => props.label.replace(/ /g, ""));

  function classes() {
    return {
      container: cssClassAssembler(
        props.classNames?.container,
        styles.container
      ),
      input: cssClassAssembler(props.classNames?.input, styles.input),
      label: cssClassAssembler(props.classNames?.label, styles.label),
    };
  }

  return (
    <div className={classes().container}>
      <div className={styles.labelWithCopy}>
        <label className={classes().label} htmlFor={id}>
          {props.label}
        </label>
        <CopyToClipboardButton
          successCallback={props.copyDoneCallback}
          text={props.text}
        />
      </div>
      <Spacer y={2} />
      <input
        type="text"
        id={id}
        value={props.text}
        readOnly
        className={classes().input}
      />
    </div>
  );
}

export default InputWithCopyButton;
